export function getDateTwoDaysAgo(currentDate: Date): Date {
  return new Date(currentDate.setDate(currentDate.getDate() - 2))
}
